import {Component, Input, NgZone, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {TermsAndConditionComponent} from 'src/app/components/terms-condition/terms-condition.component';
import {StorageService} from '../../../../../_services/storage.service';
import {Roles} from '../../../../../_model';
import {environment} from '../../../../../../environments/environment';
import {ChooseEmotionComponent} from '../choose-emotion/choose-emotion.component';
import {ReportPublishedComponent} from '../report-published/report-published.component';
import {Location} from '@angular/common';
import {CommonService} from '../../../../../_services/common.service';
import {LocalStorageService, UserService} from '../../../../../_services';
import {LoadingService} from '../../../../../_services/loading.service';
import {ToastService} from '../../../../../_services/toast.service';
import {ConstantProvider} from '../../../../../_services/constants.service';

@Component({
  selector: 'app-you-act-why-add-report',
  templateUrl: './you-act-add-report.component.html',
  styleUrls: ['./you-act-add-report.component.scss'],
})
export class YouActAddReportComponent implements OnInit {

  @Input() report: any = {};
  engagementList: any[] = [];
  engagementSelected: any[] = [];
  reportForm: FormGroup;
  progressBarValue = 0.125;
  progressBarValueInc = 0.125;
  pageIndex = 1;
  lastPage = 0;
  emotions = [];
  emotionList = [];
  reportsText: any;
  textAreaMaxLength = 100;
  profileImage = '';
  pictureAdded = false;
  guestUserObj: any;
  enableGuest = false;
  project: { type: string; logo: string } = {type: '', logo: ''};
  currentUser: any;
  serverUrl = environment.server + '/public';
  submitted = false;

  constructor(public translate: TranslateService,
              private router: Router,
              private location: Location,
              public loadingService: LoadingService,
              public toast: ToastService,
              private commonService: CommonService,
              private storageService: StorageService,
              private userService: UserService,
              private ngZone: NgZone,
              private activatedRoute: ActivatedRoute,
              private localStorageService: LocalStorageService,
              public modalController: ModalController,
              public constant: ConstantProvider,
              public platform: Platform) {
    this.engagementList = this.constant.engagementList;
    const projectType = localStorage.getItem('projectType');
    [this.project.type, this.project.logo] = this.commonService.getProjectLogo(projectType);
    this.currentUser = this.localStorageService.get(environment.currentUser);
    if (this.project.type === 'space') {
      this.progressBarValueInc = 0.167;
    } else {
      this.progressBarValueInc = 0.125;
    }
    this.pageIndex = 1;
    this.constructForm();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.hasOwnProperty('id')) {
        this.setValues(params.id);
      } else {
        this.report = {};
        this.report = params;
        // this.reportForm.get('reportTitle').setValue(this.report.title);
      }
    });
  }

  ngOnInit() {
    this.translate.get(['reports']).subscribe(
      (values) => {
        this.reportsText = values.reports;
      });
    this.guestUser();
    if (this.guestUserObj === null || (this.guestUserObj && this.guestUserObj.role === Roles.user)) {
      this.enableGuest = true;
    }
    // this.setValues();
  }

  setValues(id) {
    this.userService.getMyEmotionReportById(id)
      .subscribe((data) => {
        this.report = data.reportDetail;
        this.setFormValues();
      }, error => {
        console.error('error');
      });
  }

  setFormValues() {
    if (this.report) {
      if (this.report.emotions) {
        const currentUser = this.localStorageService.get(environment.currentUser);
        if (currentUser) {
          this.reportForm.get('gender').setValue(currentUser.user.profile.profileDetails.gender);
          this.reportForm.get('age').setValue(currentUser.user.profile.profileDetails.age);
          this.reportForm.get('postCode').setValue(this.currentUser.user.profile.profileDetails.postCode);
        }
        this.emotionList = this.report.emotions;
        this.report.emotions.forEach((emotions) => {
          this.emotions.push({id: emotions.toLowerCase(), name: emotions});
        });
        if (this.emotions.length === 1) {
          this.reportForm.get('totalEmotion').setValue(this.emotions.length + ' ' + 'emotion selected');
        } else {
          this.reportForm.get('totalEmotion').setValue(this.emotions.length + ' ' + 'emotion selected');
        }
      }
      if (this.report.image) {
        this.profileImage = this.serverUrl + this.report.image;
      }
      if (this.report.answers) {
        if (this.report.answers[0].feel) {
          this.reportForm.get('feel').setValue(this.report.answers[0].feel);
        }
        if (this.report.answers[0].feelConnection) {
          this.reportForm.get('feelConnection').setValue(this.report.answers[0].feelConnection);
        }
        if (this.report.answers[1]) {
          if (this.report.answers[1].changePlace) {
            this.reportForm.get('changePlace').setValue(this.report.answers[1].changePlace);
          }
          if (this.report.answers[1].customChangePlace) {
            this.reportForm.get('customChangePlace').setValue(this.report.answers[1].customChangePlace);
          }
          if (this.report.answers[1].customChangePlaceRequired) {
            this.reportForm.get('customChangePlaceRequired').setValue(this.report.answers[1].customChangePlaceRequired);
          }
          if (this.report.answers[1].improvePlace) {
            this.reportForm.get('improvePlace').setValue(this.report.answers[1].improvePlace);
          }
          if (this.report.answers[1].improvePlaceDescription) {
            this.reportForm.get('improvePlaceDescription').setValue(this.report.answers[1].improvePlaceDescription);
          }
          if (this.report.answers[2].engagementSelected) {
            this.engagementSelected = this.report.answers[2].engagementSelected;
          }
          if (this.report.answers[2].engagementSelected) {
            this.reportForm.get('govtPolicy').setValue(this.report.answers[2].govtPolicy);
          }
        }
      }
    }
  }

  // convenience getter for easy access to form fields
  // eslint-disable-next-line @typescript-eslint/member-ordering
  get field(): any {
    return this.reportForm.controls;
  }

  constructForm() {
    this.reportForm = new FormGroup({
      totalEmotion: new FormControl('', []),
      feel: new FormControl('', [Validators.maxLength(100)]),
      changePlace: new FormControl('notSay', []),
      improvePlace: new FormControl('notSay', []),
      improvePlaceDescription: new FormControl('', []),
      feelConnection: new FormControl('notSay', []),
      customChangePlace: new FormControl('', []),
      reportTitle: new FormControl('', []),
      govtPolicy: new FormControl('', []),
      customChangePlaceRequired: new FormControl('', []),
      agree: new FormControl(false, []),
      email: new FormControl('', []),
      age: new FormControl('', [Validators.required]),
      postcode: new FormControl('', []),
      phoneNumber: new FormControl('', []),
      gender: new FormControl('', [Validators.required]),
      customGender: new FormControl('', []),
      language: new FormControl('', []),
      customLanguage: new FormControl('', []),
      identity: new FormControl('', []),
      customIdentity: new FormControl('', [])
    });
  }

  async guestUser() {
    this.guestUserObj = await this.storageService.get(environment.userObj);
  }

  async chooseEmotion() {
    const modal = await this.modalController.create({
      component: ChooseEmotionComponent,
      componentProps: {
        parentEmotions: this.emotions,
        maxEmotions: 3,
        addReport: true
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    modal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          this.emotions = data.data;
          if (this.emotions.length > 0) {
            this.emotionList = [];
            this.emotions.forEach(emotionObj => {
              this.emotionList.push(emotionObj.name);
            });

            if (this.emotions.length === 1) {
              this.reportForm.get('totalEmotion').setValue(this.emotions.length + ' ' + this.reportsText.emotion_selected);
            } else {
              this.reportForm.get('totalEmotion').setValue(this.emotions.length + ' ' + this.reportsText.emotions_selected);
            }
          }
        }
      });
    return await modal.present();
  }

  chooseEmotionPage() {
    this.ngZone.run(() => {
      this.pageIndex = 1;
      this.progressBarValue = this.progressBarValueInc;
    });
  }

  addMoreInfo() {
    this.ngZone.run(() => {
      if (this.emotions.length === 0) {
        this.submitted = true;
        return;
      }
      this.submitted = false;
      this.pageIndex = 2;
      this.progressBarValue = this.progressBarValueInc * 2;
    });
  }

  addPicture() {
    this.pictureAdded = !this.pictureAdded;
  }

  changePlacePage() {
    this.ngZone.run(() => {
      this.pageIndex = 3;
      this.progressBarValue = this.progressBarValueInc * 3;
    });
  }

  completeReport(lastPage?: number) {
    this.ngZone.run(() => {
      if (lastPage === 1) {
        this.lastPage = lastPage;
      }
      if (this.project.type === 'space') {
        this.pageIndex = 6;
        this.progressBarValue = this.progressBarValueInc * 6;
      } else {
        this.pageIndex = 7;
        this.progressBarValue = this.progressBarValueInc * 7;
      }
    });
  }

  async publish() {
    const tncAccepted = this.reportForm.value.agree;
    if (tncAccepted === false && this.pageIndex > 1) {
      this.toast.error('Please accept terms & condition');
      return;
    }
    this.loadingService.show();
    const emotionReport = {
      title: this.reportForm.value.reportTitle === '' ? this.report.title : this.reportForm.value.reportTitle,
      address: this.report.address,
      emotions: this.emotionList,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      location_name: this.report.title,
      location: this.report.location,
      reportType: this.report.type,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_details: {
        gender: this.reportForm.value.gender,
        email: this.reportForm.value.email || '',
        age: this.reportForm.value.age,
        pin: this.reportForm.value.postCode || '2000',
        postCode: this.reportForm.value.postCode || '2000',
        phoneNumber: this.reportForm.value.phoneNumber || '',
      },
      climateChange: {
        gender: this.reportForm.value.gender,
        age: this.reportForm.value.age,
        pin: this.reportForm.value.postCode || '2000',
      },
      answers: [
        {
          feelConnection: this.reportForm.value.feelConnection,
          feel: this.reportForm.value.feel
        },
        {
          changePlace: this.reportForm.value.changePlace,
          customChangePlace: this.reportForm.value.customChangePlace,
          customChangePlaceRequired: this.reportForm.value.customChangePlaceRequired,
          improvePlace: this.reportForm.value.improvePlace,
          improvePlaceDescription: this.reportForm.value.improvePlaceDescription
        },
        {
          engagementSelected: this.engagementSelected,
          govtPolicy: this.reportForm.value.govtPolicy
        }
      ],
      image: this.profileImage.replace(this.serverUrl, ''),
      projectType: this.project.type,
      // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
      user_id: this.currentUser === null ? '' : this.currentUser.user._id
    };
    if (this.report.hasOwnProperty('_id')) {
      // eslint-disable-next-line no-underscore-dangle
      this.userService.updateEmotionReport(emotionReport, this.report._id)
        .subscribe((data) => {
          this.emotionPublished(data[0]);
          this.loadingService.hide();
        }, (error) => {
          this.loadingService.hide();
          console.error(error, 'error');
        });
    } else {
      this.userService.createEmotionReport(emotionReport)
        .subscribe((data) => {
          this.emotionPublished(data);
          this.loadingService.hide();
        }, (error) => {
          console.error(error, 'error');
          this.loadingService.hide();
        });
    }
  }

  async emotionPublished(data?: any) {
    this.localStorageService.set('report_created', true);
    this.progressBarValue = 1;
    const modal = await this.modalController.create({
      component: ReportPublishedComponent,
      componentProps: {
        report: data
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: false
    });
    return await modal.present();
  }

  back() {
    if (this.lastPage === 1) {
      this.lastPage = 0;
      this.chooseEmotionPage();
      return;
    }
    switch (this.pageIndex) {
      case 1:
        this.location.back();
        break;
      case 2:
        this.chooseEmotionPage();
        break;
      case 3:
        this.addMoreInfo();
        break;
      case 4:
        this.changePlacePage();
        break;
      case 5:
        this.engage();
        break;
      case 6:
        this.aboutYou();
        break;
      case 7:
        this.personalInfo();
        break;
      default:
        this.chooseEmotionPage();
    }
  }

  async terms() {
    const modal = await this.modalController.create({
      component: TermsAndConditionComponent,
      componentProps: {
        report: this.report
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  onSubmit() {

  }

  fileUploading($event: any) {
    this.loadingService.show();
  }

  onFileUploadDone(image: any) {
    this.loadingService.hide();
    this.profileImage = this.serverUrl + '/upload/' + image.filename;
  }

  onFileUploadError($event: any) {

  }

  gotToTop() {

  }

  engage() {
    this.ngZone.run(() => {
      this.pageIndex = 4;
      this.progressBarValue = this.progressBarValueInc * 4;
    });
  }

  addRemove(option): void {
    if (this.engagementSelected.indexOf(option) > -1) {
      this.engagementSelected.splice(this.engagementSelected.indexOf(option), 1);
    } else {
      this.engagementSelected.push(option);
    }
  }

  aboutYou() {
    this.ngZone.run(() => {
      this.pageIndex = 5;
      this.progressBarValue = this.progressBarValueInc * 5;
    });
  }

  personalInfo() {
    this.submitted = true;
    if (!this.reportForm.value.gender && this.project.type !== 'space') {
      this.toast.error('You must answer all mandatory questions.');
      return;
    }
    if (!this.reportForm.value.age) {
      this.toast.error('You must answer all mandatory questions.');
      return;
    }
    this.submitted = false;
    if (this.project.type === 'space') {
      this.pageIndex = 5;
      this.progressBarValue = this.progressBarValueInc * 5;
    } else {
      this.pageIndex = 6;
      this.progressBarValue = this.progressBarValueInc * 6;
    }
  }
}
